exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".file-uploader-main-container{padding:16px;border:1px solid #e8e8e8;border-radius:3px;width:100%;display:inline-block}.file-uploader-main-container .file-uploader-container{display:flex;flex-direction:column;font-family:sans-serif}.file-uploader-main-container .file-uploader-container .dropzone{flex:1;display:flex;flex-direction:column;align-items:center;padding:20px;border-width:2px;border-radius:2px;border-color:#eee;border-style:dashed;background-color:#fafafa;color:#bdbdbd;outline:none;transition:border .24s ease-in-out}", ""]);

// exports
